/** Hit target for the icon-only tab control (Tailwind `size-7.5`). */
export const PRIMARY_NAVIGATION_STRIP_ICON_HIT_TARGET_PX = 30;

/**
 * Space above the icon and below it inside the tab row. The below gap sits above the safe-area /
 * home-indicator clearance. Matches the 9px chrome edge gutter used elsewhere in the shell.
 */
export const PRIMARY_NAVIGATION_STRIP_ICON_VERTICAL_INSET_PX = 9;

/** Icon hit target plus equal vertical insets above and below, before bottom clearance begins. */
export const PRIMARY_NAVIGATION_BAR_BASE_ROW_HEIGHT =
  PRIMARY_NAVIGATION_STRIP_ICON_HIT_TARGET_PX + PRIMARY_NAVIGATION_STRIP_ICON_VERTICAL_INSET_PX * 2;
